import LazyLoad from "react-lazyload";
import styles from "./judge.module.css";
const Judge = ({ resources }) => {
  return (
    <section className={styles.ctn}>
      <h1>Judge</h1>
      <div className={styles.contentBox}>
        <LazyLoad>
          <img src={`${resources}m3challenge-chrishau.png`} className={styles.img} alt="" />
        </LazyLoad>
        <div>
          <h3>Chris Hau</h3>
          <h5>
            Chris Hau is a YouTuber, Instagram influencer, and Creative Director
            from Toronto, Canada. A creative storyteller at heart, he's an
            expert at crafting innovative and engaging content. His powerful
            imagery, relentless dedication, and passion to create have built a
            loyal following of filmmakers, photographers, and travel enthusiast
            around the world.
          </h5>
        </div>
      </div>
    </section>
  );
};

export default Judge;
